import { render, staticRenderFns } from "./assuntos-interesse-deficiente-visual.vue?vue&type=template&id=ce22fe6a&"
import script from "./assuntos-interesse-deficiente-visual.vue?vue&type=script&lang=ts&"
export * from "./assuntos-interesse-deficiente-visual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce22fe6a')) {
      api.createRecord('ce22fe6a', component.options)
    } else {
      api.reload('ce22fe6a', component.options)
    }
    module.hot.accept("./assuntos-interesse-deficiente-visual.vue?vue&type=template&id=ce22fe6a&", function () {
      api.rerender('ce22fe6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa-deficiente-visual/assuntos-interesse-deficiente-visual.vue"
export default component.exports